module.exports = __webpack_public_path__ + "static/media/29ADMSPC29.de8dc12e.jpg";